module.exports = __webpack_public_path__ + "images/img-217phpY.png";


//////////////////
// WEBPACK FOOTER
// ./frontend/cabinets/apps/rocket/assets/img/keitaro-integration/en/5.png
// module id = 2341
// module chunks = 0